import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from '../../../components/card/card';
import useGetRotationPlan from '../../../hooks/HR/use-get-RotationPlan.js';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../Helper/Permisstions/usePermissions';
import Loading from '../../../components/Shared/Loader/Loading';
import { Link } from 'react-router-dom';
import ModalComponent from '../../../components/Modal/ModalComponent';
import CreateRotationPlan from './CreateRotationPlan';
import { useNavigate } from 'react-router-dom';
import NtxTable from '../../../components/DataTable/NtxTable';
import showConfirmation from '../../../components/Shared/Alert/Confirmation';
import { useDispatch } from 'react-redux';
import { DeletedRotationPlan, GetRotationPlan } from '../../../store/HR/Raqeeb/raqeebSlice';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';

function RotationPlan() {
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleDeleteRotationPlan = (id) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeletedRotationPlan(id))
        .unwrap()
        .then(() => {
          dispatch(GetRotationPlan());
          CustomAlert({ action: 'Add', msg: 'تمت عملية الحذف بنجاح' });
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  // ________________

  const { RotationPlanList, loading, error } = useGetRotationPlan();

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Start Date'), key: 'Start' },
    { title: t('Date_TO'), key: 'Date' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = RotationPlanList?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Start: item.startDate,
      Date: item.endDate,
      action: (
        <>
          {HasPermission('ViewDetailsRaqRotationPlans') && (
            <>
              <button
                type="button"
                onClick={() => Navigate(`${item.id}/RotationSetting`)}
                className="btn btn-sm btn-outline-theme me-1">
                <i className="fab fa-lg fa-fw me-2 fa-whmcs"></i>
                {t('PlanSettings')}
              </button>
            </>
          )}

          {HasPermission('AssignEmployeesToAttendancePlan') && (
            <button
              type="button"
              className="btn btn-sm btn-outline-theme me-1"
              onClick={() =>
                Navigate(`${item.id}/AssignmentPerson`, {
                  state: {
                    name: i18n.language === 'en' ? item.name : item.name2,
                  },
                })
              }>
              <i className="fas fa-users-cog fa-lg fa-fw me-2"></i>
              {t('employees')}
            </button>
          )}

          {HasPermission('ViewDetailsRaqRotationPlans') && (
            <>
              <button
                type="button"
                onClick={() =>
                  Navigate(`${item.id}/CalendarSchedules`, {
                    state: {
                      name: i18n.language === 'en' ? item.name : item.name2,
                    },
                  })
                }
                className="btn btn-sm btn-outline-theme me-1">
                {/* <i className="fas fa-trash-alt fa-lg me-2   "></i> */}
                {t('ViewSchedulingDays')}
              </button>
            </>
          )}
          {HasPermission('EditRaqRotationPlans') && (
            <>
              <button
                type="button"
                onClick={() => handleDeleteRotationPlan(item.id)}
                className="btn btn-sm btn-outline-danger me-1">
                <i className="fas fa-trash-alt fa-lg me-2   "></i>
                {t('Delete')}
              </button>
            </>
          )}
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: t('RotationPlan'),
      link: null,
    },
  ];

  return (
    <>
      <div className="row">
        <div className="d-flex align-items-center">
          <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('RotationPlanRaqeeb')} />
          {HasPermission('AddRaqRotationPlans') && (
            <div className="ms-auto">
              <Link
                to=""
                className="btn me-1 btn-theme"
                data-bs-toggle="modal"
                data-bs-target="#modalAdd">
                <i className="fa fa-plus-circle fa-fw me-1"></i>
                {t('AddRotationPlan')}
              </Link>
            </div>
          )}
        </div>

        <Card>
          {/* <Loader  /> */}
          <Loading loading={loading} error={error}>
            <CardBody>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={10}
                theadClass=""
                tableClass="table text-nowrap table-hover "
                enableSearch
                showRecordsSelector
              />
            </CardBody>
          </Loading>
        </Card>

        <div />
      </div>

      <ModalComponent title={t('AddRotationPlan')} id="modalAdd" size="lg">
        <CreateRotationPlan />
      </ModalComponent>
    </>
  );
}

export default RotationPlan;
